import { AfterViewInit, Component, EventEmitter, Output, ViewChild } from "@angular/core";
import moment from "moment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { RefundsService } from "../../../../auth/service/refunds.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { TutorialService } from "../../../../auth/service/tutorial.service";

@Component({
  selector: "app-request-refund-modal",
  templateUrl: "./request-refund-modal.component.html",
})
export class RequestRefundModalComponent implements AfterViewInit {
  @ViewChild("content") content;
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  public formGroup: FormGroup;
  public showModalErrors: boolean = false;
  public attachments_list: Array<any> = [];
  public attachments_list_obj: Array<any> = [];

  constructor(
    public _modalService: NgbModal,
    private _formBuilder: FormBuilder,
    public _refundService: RefundsService,
    public _utilService: UtilsService,
    public _tutorialService: TutorialService,
  ) {
    this.formGroup = this._formBuilder.group({
      amount: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      note: new FormControl(""),
      date: new FormControl(moment(), [Validators.required]),
    });
  }

  ngAfterViewInit() {
    this._modalService.open(this.content, {
      centered: true,
      size: "sm",
      backdrop: false,
      keyboard: false,
    });
    this.showModalErrors = false;
  }

  modalClose() {
    this._modalService.dismissAll();
    this.formGroup.reset();
    this.onClose.emit();
  }

  async uploadAttachments(order_id: number) {
    // I'll wait for all attachments to be uploaded
    await Promise.all(
      this.attachments_list.map((file: File) => this._refundService.uploadAttachment(file, order_id)),
    ).catch(() => this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE" }));
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showModalErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  async addAttachmentToList(files: any) {
    // I create a variable from the actual list
    let updatedList: any[] = this.attachments_list_obj.filter((item: any) => item.name !== "");
    //For all files charged in the queue
    for (let file of files) {
      //check dimensions
      if (file.size > 10000000) {
        await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      // controllo estensione file
      if(!file.type.includes("image") && file.type !== "application/pdf") {
        await this._utilService.showSWALError({ text: "ERROR_FILE_NOT_IMAGE_OR_PDF" });
        continue;
      }

      //If exits in the list I'll remove it
      const exists: any = updatedList.find((item: any) => item.name === file.name);
      // If exists remove it
      if (exists) {
        updatedList = updatedList.find((item: any) => item.name === file.name);
      }
      //If it does not exist I'll add it
      else {
        this.attachments_list.push(file);
      }
      //Add to updated list
      updatedList.push({
        name: file.name,
        size: this._utilService.formatBytes(file.size),
        status: 0,
      });
    }
    //I update the variable for the page
    this.attachments_list_obj = updatedList;
  }

  resetAttachmentsList() {
    this.attachments_list_obj = [];
    this.attachments_list = [];
  }

  removeAttachmentFromList(index: any) {
    this.attachments_list_obj = this.attachments_list_obj.filter((item: any, i: number) => i !== index);
    this.attachments_list = this.attachments_list.filter((item: any, i: number) => i !== index);
  }

  formatNumber() {
    this.formGroup.patchValue({ amount: this._utilService.addDotsToNumber(this.formGroup.value.amount) });
  }

  async requireRefund() {
    this.showModalErrors = true;
    // controllo valori
    if (this.attachments_list.length < 1 || this.attachments_list_obj.length < 1) {
      await this._utilService.showSWALError({ text: "ERROR_FILE_REQUIRE" });
      return false;
    }
    if (this.formGroup.invalid) {
      return false;
    }

    this._utilService.showLoading();
    await this._refundService.create(this.formGroup.value)
      .then(async (response: { file_name: string; id: number }) => {
        this.modalClose();
        if (this.attachments_list && this.attachments_list.length > 0) {
          await this.uploadAttachments(response.id);
        }
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_SEND_REFUND" });
      });
  }
}
